import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { LoginService } from 'src/app/services/login.service';
import { WhitelabelService } from 'src/app/services/whitelabel.service';
import { LoginResponse } from '../../models/Responses/LoginRespose';
import { Constants } from '../../Constants/Constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TwoFactorResponse } from 'src/app/models/Responses/TwoFactorResponse';


@Component({
  selector: 'app-twofactor',
  templateUrl: 'twofactor.component.html',
  styleUrls: ['twofactor.component.scss'],
})

export class TwofactorComponent implements OnInit {
  title = 'ProcessEye';
  appName = "processEye";
  loading: boolean = false;
  logged: boolean = true;
  error: number = 0;
  showQrCode: boolean = false;
  qrCode: string = "";
  userName: string = "";
  token: string = "";
  authenticatorCode: string = "";

  constructor(private router: Router, private loginService: LoginService, private auth: AuthService, private routeAct: ActivatedRoute, private http: HttpClient,
    private whitelabelService: WhitelabelService) {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state;
    this.userName = state.user;
    this.token = state.token;


    this.getTwoFactorData().subscribe({
      next: (data: TwoFactorResponse) => {
        console.log(data);
        this.showQrCode = data.showQr;
        if (data.showQr) {
          this.qrCode = data.qrCode;
          this.authenticatorCode = data.code;
          this.userName = data.userName;
        }


      }, error: (err) => {
        console.log("Error", err);
        debugger;
        this.loading = false;
        this.logged = false;
        this.error = err;
      }
    });

  }


  ngOnInit() {
  }

  password = new FormControl('', [
    Validators.required,
  ]);

  handleKeyUp(e) {
    if (e.keyCode === 13) {
      this.login();
    }
  }

  getTwoFactorData() {
    const request = { User: this.userName, Token: this.token }
    return this.http.post<any>(environment.apiBaseUrl + '/Account/GetTwoFactor', request)
  }

  login() {
    this.twoFactoLogin().subscribe({
      next: (data: LoginResponse) => {

        if (data.result == 0) {

          console.log(data);
          localStorage.setItem(Constants.Token, data.token);
          localStorage.setItem(Constants.UserName, data.designerLoginName)
          localStorage.setItem(Constants.IsCreator, String(data.isCreator));
          localStorage.setItem(Constants.IsReviewer, String(data.isReviewer));
          localStorage.setItem(Constants.IsTechManager, String(data.isTechManager));
          localStorage.setItem(Constants.IsDesignerManager, String(data.isDesignerManager));
          this.whitelabelService.setClientWhitelabel(data.whiteLabelName);
          this.auth.getLogExpirationDate();
          this.logged = true;
          if (this.auth.IsReviewer())
            this.router.navigate(['/workflowreport'], { queryParamsHandling: "preserve" });

          if (this.auth.IsCreator() || this.auth.IsTechManager() || this.auth.IsDesignerManager())
            this.router.navigate(['/dashboard'], { queryParamsHandling: "preserve" });
        } else {
          this.logged = false;
        }
        this.loading = false;
      },
      error: (err) => {
        console.log(err);
        this.loading = false;
        this.logged = false;
        this.error = err.error;
      }
    });
  }

  goBack() {
    this.router.navigate(['/login']);
  }

  twoFactoLogin() {
    const request = { Code: this.password.value, UserName: this.userName, Token: this.token }
    return this.http.post<any>(environment.apiBaseUrl + '/Account/TwoFactorLogin', request, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8', })
    })
  }

}
